var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikessmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.82c-.16 0-.3-.02-.43-.06C3.66 10.11.62 7.78.62 4.35A3.16 3.16 0 0 1 6 2.1a3.1 3.1 0 0 1 2.22-.92 3.17 3.17 0 0 1 3.15 3.17c0 3.44-3.03 5.76-4.94 6.41a1.3 1.3 0 0 1-.43.06Zm-2.22-8.9a2.42 2.42 0 0 0-2.4 2.43c0 3.41 3.28 5.31 4.44 5.7a.8.8 0 0 0 .37 0c1.15-.39 4.44-2.28 4.44-5.7a2.42 2.42 0 0 0-2.4-2.42c-.77 0-1.47.35-1.93.97-.13.19-.46.19-.6 0a2.39 2.39 0 0 0-1.92-.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikessmall);
export default __webpack_public_path__ + "static/media/likes.small.5bd36c6c2154337202516cd72292172c.svg";
export { ForwardRef as ReactComponent };